import React, { useState, useEffect, useContext } from 'react';
import {  CircularProgress, makeStyles } from '@ellucian/react-design-system/core';
import { useApi } from '../ApiContext';
import MFAContext from './MFAContext';
import QRCode from './QRCode';
import OTPVerification from './OTPVerification';
import { spacing40, spacing80, spacing90 } from '@ellucian/react-design-system/core/styles/tokens';

const useStyles = makeStyles((theme) => ({
    registerContainer: {
        margin:'4rem auto 0 auto',
        padding: `0 ${spacing80} 0 ${spacing80}`,
        maxWidth: '1280px',
        display: 'grid',
        gridTemplateColumns: '6fr 4fr',
        [theme.breakpoints.down('sm')]: {
            display: 'flex',
            flexDirection: 'column',
            margin:'0',
            padding: `0 ${spacing40} 0 ${spacing40}`,
        },
    },
    loginContainer: {
        margin:'4rem auto 0 auto',
        padding: `0 ${spacing80} 0 ${spacing80}`,
        maxWidth: '1280px',
    },
    loadingSpinner: {
        display: 'flex',
        justifyContent: 'center',
        padding: spacing90,
    },
}));

const MFAHome = () => {
    const classes = useStyles();
    const api = useApi();
    const { qrCodeInfo, setQRCodeInfo } = useContext(MFAContext);
    const [isLoading, setIsLoading] = useState(null);

    useEffect(() => {
        const fn = async () => {
            try{
                setIsLoading(true);
                const qrCodeDetails = await api.mfaAuth.checkUser();
                if(!qrCodeDetails.otpVerified){
                    // For user register
                    setQRCodeInfo({
                        ...qrCodeDetails,
                    });
                } 
                else {
                    // For user login
                    setQRCodeInfo({
                        ...qrCodeInfo,
                        ...qrCodeDetails,
                    });
                }
                setIsLoading(false);
            }
            catch (e) {
                console.error(e);
                throw e;
            }            
        };
        fn();
    }, []);

    return (
        <div>
            {isLoading &&
                <div className={classes.loadingSpinner}>
                    <CircularProgress />
                </div>
            }
            {!isLoading &&
                <div className={!qrCodeInfo.otpVerified ? classes.registerContainer : classes.loginContainer}>
                    {!qrCodeInfo.otpVerified && 
                        <QRCode />
                    }
                    <OTPVerification />
                </div>
            }
        </div>
    );
};

export default MFAHome;